import { defineComponent as _defineComponent } from 'vue'
import {
        countAffectedTHGUsers,
        exportTHGCars,
        exportTHGCarsUBA,
        fetchTHGCars,
    } from '@/api/thg/cars';
    import { THGCarPaginatedResponse } from '@/interfaces/thg/THGCarPaginatedResponse';
    import GenericTHGCarTable from '@/components/thg/cars/GenericTHGCarTable.vue';
    import { computed, onMounted, ref, watch } from 'vue';
    import THGCarFilters from '@/components/thg/cars/THGCarFilters.vue';
    import emitter from '@/utils/mitt';
    import { useTHGCarStore } from '@/storenew/thg/cars';
    import THGCarActions from '@/components/thg/cars/THGCarActions.vue';
    import { storeToRefs } from 'pinia';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { alertInfo } from '@/utils/dialogs';
    import { debounce } from 'lodash';
    import { generate_download } from '@/utils/files';
    import { Country } from '@/enums/Country';
    import auth from '@/store/auth/auth';

    interface Props {
        pageSize?: number;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGCarList',
  props: {
    pageSize: { default: 20 }
  },
  setup(__props: any) {

const props = __props as { pageSize: number };

    

    const { currentCountry } = storeToRefs(useTHGGlobalStore());
    const data = ref<THGCarPaginatedResponse>();
    const currentPageNum = ref<number>(1);

    const isPaginated = computed<boolean>(() => {
        return Boolean(data.value?.total_results && data.value?.total_results > props.pageSize);
    });

    const { filterParam } = storeToRefs(useTHGCarStore());

    const countUsersButtonIsLoading = ref<boolean>(false);
    async function countUsers() {
        countUsersButtonIsLoading.value = true;

        const resp = await countAffectedTHGUsers(filterParam.value);
        alertInfo(
            'Info',
            `Betroffene User: <strong>${resp.parsedBody?.total_affected_users}</strong>`,
        );

        countUsersButtonIsLoading.value = false;
    }

    async function doDataFetching(pageNum: number) {
        emitter.emit('showLoader');
        data.value = (await fetchCars(pageNum)) as THGCarPaginatedResponse;
        emitter.emit('hideLoader');
    }

    async function onPageChange(pageNum: number) {
        currentPageNum.value = pageNum;
        await doDataFetching(currentPageNum.value);
    }

    async function fetchCars(pageNum: number) {
        const { sortData } = useTHGCarStore();

        const response = await fetchTHGCars(
            filterParam.value,
            sortData.field,
            sortData.order,
            props.pageSize,
            pageNum,
        );

        const cars = response.parsedBody;

        if (cars) {
            return cars;
        } else {
            throw new Error('Error while getting thg cars.');
        }
    }

    async function onDataReloading() {
        await doDataFetching(currentPageNum.value);
    }

    watch(
        filterParam,
        // debounce the watcher, we don't want to make requests too often when typing
        debounce(async () => {
            // filter changed: start from first page, the current page may not exist anymore
            currentPageNum.value = 1;
            await doDataFetching(currentPageNum.value);
        }, 500),
        { deep: true, immediate: false },
    );

    async function exportUBA() {
        emitter.emit('showLoader');

        const blobUrl = await exportTHGCarsUBA(filterParam.value);

        emitter.emit('hideLoader');

        const currentDate = new Date();
        const dateStr = currentDate.toLocaleDateString().replaceAll('.', '');
        const timeStr = currentDate.toLocaleTimeString().replaceAll(':', '');

        const filename = `CRM-Export_elSa_NöP_${dateStr}_${timeStr}.xlsx`;

        generate_download(blobUrl, filename);
    }

    async function exportCurrentData() {
        emitter.emit('showLoader');

        const { sortData } = useTHGCarStore();
        const blobUrl = await exportTHGCars(filterParam.value, sortData.field, sortData.order);

        emitter.emit('hideLoader');
        const currentDate = new Date();
        const dateStr = currentDate.toLocaleDateString().replaceAll('.', '-');
        const timeStr = currentDate.toLocaleTimeString().replaceAll(':', '');

        const filename = `Export_THG_Fahrzeuge_${currentCountry.value.toUpperCase()}_${dateStr}_${timeStr}.xlsx`;

        generate_download(blobUrl, filename);
    }

    onMounted(async () => {
        // get initial data
        await doDataFetching(1);

        // reset the user_id in filter parameter
        filterParam.value.user_id = undefined;
    });

return { __sfc: true,props, currentCountry, data, currentPageNum, isPaginated, filterParam, countUsersButtonIsLoading, countUsers, doDataFetching, onPageChange, fetchCars, onDataReloading, exportUBA, exportCurrentData, GenericTHGCarTable, THGCarFilters, THGCarActions, Country, auth }
}

})